/**
 * AccessBadgeSubHeader — sub-header content for entity types that show
 * only the privacy / visibility badge (meeting notes, files).
 *
 * Renders the EmailThreadVisibilityBadge from `object.access_summary`.
 * Returns null when access_summary is absent (badge handles this internally).
 *
 * Registered on the entity type registry `components.subHeader` for
 * `ahoy_meeting_notes` and `ahoy_file`.
 */

import type { CrmObject } from '@/types/crm';

import { EmailThreadVisibilityBadge } from '../../components/EmailThreadVisibilityBadge';

export function AccessBadgeSubHeader({ object }: { object: CrmObject }) {
  return <EmailThreadVisibilityBadge access_summary={object.access_summary} />;
}
